/* eslint-disable react/button-has-type */
import React, { Fragment, useContext } from 'react';
import { OPERATIONS, TECHNICAL_SUPPORT } from '../../../../../../../utils/departments/helpers';
import RequisitionContext from '../../../../../../../context/shared/requisitions/RequsitionContext';

const FieldSupportFilters = () => {
  const {
    account,
    department,
    onChange,
    getFieldSupportRequisition,
    onChangeAccountStatus,
    getRequisitionByAccountStatus,
  } = useContext(RequisitionContext);
  const submit = () => department.length > 0;
  const submitStatus = () => account.department.length > 0 && account.status.length > 0;
  return (
    <>
      <p className="fliter copy-font d-flex mr-auto">
        <small className="mt-2 text-nowrap" style={{ paddingLeft: '8%' }}>
          Filter By:
        </small>
        <span>
          <select className="form-control" name="department" onChange={onChange}>
            <option>Select Departments</option>
            <option value="technical">Technical Support</option>
            <option value="operations">Operations</option>
          </select>
        </span>

        <button
          onClick={() => getFieldSupportRequisition(department)}
          className="btn btn-green copy-font my-1"
          disabled={!submit()}
        >
          Search Requisition
        </button>
      </p>
      <p className="fliter copy-font d-flex mr-auto">
        <small className="mt-2">Filter By:</small>
        <span>
          <select className="form-control" name="department" onChange={onChangeAccountStatus}>
            <option>Select By Departments</option>
            <option value={`${TECHNICAL_SUPPORT}`}>Technical Support</option>
            <option value={`${OPERATIONS}`}>Operations</option>
          </select>
        </span>

        <small className="mt-2">Filter By:</small>
        <span>
          <select className="form-control" name="status" onChange={onChangeAccountStatus}>
            <option>Select By Status</option>
            <option value="rejected">Rejected</option>
            <option value="approved">Approved</option>
            <option value="queued">Queued</option>
          </select>
        </span>
        <button
          onClick={() => getRequisitionByAccountStatus(account)}
          className="btn btn-green copy-font my-1"
          disabled={!submitStatus()}
        >
          Search With Accounts Status
        </button>
      </p>
    </>
  );
};

export default FieldSupportFilters;
